import { UitkCard, UitkCardContent } from "uitk-react-cards";
import { UitkHeading } from "uitk-react-text";
import * as React from "react";
import { decorateEditorialHtml } from "components/flexComponents/Content/ContentUtilities";

/**
 * Editorial Item which will wrap text in a split column for desktop
 * and mobile pages as well as a card.
 */
export const RenderAbleContentItem = ({
  id,
  text,
  title,
  view
}: {
  id: string;
  text?: string;
  title?: string;
  view?: string;
}) => {
  return (
    <UitkCard>
      <UitkCardContent>
        <div className="uitk-card-text-segment uitk-grid">
          <div className="uitk-cell s-cell-1-1 m-cell-1-1 l-cell-1-1 xl-cell-1-1">
            <div className="uitk-type-paragraph-300" data-fm-content={id} id={id}>
              {title && (
                <UitkHeading level={2} size={600}>
                  {title}
                </UitkHeading>
              )}
              {text && (
                <div
                  className={`all-t-padding-two uitk-type-list-300${
                    view === "single-column" ? "" : " editorialTextColumn"
                  }`}
                  dangerouslySetInnerHTML={decorateEditorialHtml(text)}
                />
              )}
            </div>
          </div>
        </div>
      </UitkCardContent>
    </UitkCard>
  );
};
